export default __webpack_public_path__ + "d45341f956cff06a9b7cea100102155b.svg";